import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { GET_EG_OPERATOR, GET_FARM_USERS, GET_POLICY_LIST, GET_POLICY_REQUEST, GET_INCIDENT_TYPE } from '../constants/action-types';

export const setRequesting = data => ({ type: GET_POLICY_REQUEST, payload: data });

export const setIncidentType = data => ({ type: GET_INCIDENT_TYPE, payload: data });

export const setPolicyList = data => ({ type: GET_POLICY_LIST, payload: data });

export const setEGOperator = data => ({ type: GET_EG_OPERATOR, payload: data });

export const setFarmUsers = data => ({ type: GET_FARM_USERS, payload: data });

export const getIncidenType = farmId => dispatch => {
    defaultAgent.get(`/api/message/policy/incident-types`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setIncidentType(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(setIncidentType());
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
        dispatch(setIncidentType());
    });
};

export const getPolicyList = farmId => dispatch => {
    dispatch(setRequesting());
    defaultAgent.get(`/api/message/policy?farm_uuid=${farmId}`).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setPolicyList(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(setPolicyList());
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
        dispatch(setPolicyList());
    });
};

export const addMessagePolicy = params => dispatch => {
    defaultAgent.post(`/api/message/policy`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(getPolicyList(params.farm_uuid));
        }
        else if (agentResult.message) {
            dispatch(getPolicyList(params.farm_uuid));
            dispatch(toastSuccess(agentResult.message));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
    });
};

export const editMessagePolicy = params => dispatch => {
    defaultAgent.put(`/api/message/policy`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(getPolicyList(params.farm_uuid));
        }
        else if (agentResult.message) {
            dispatch(getPolicyList(params.farm_uuid));
            dispatch(toastSuccess(agentResult.message));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
    });
};

export const deleteMessagePolicy = params => dispatch => {
    defaultAgent.post(`/api/message/delete/policy`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(getPolicyList(params.farm_uuid));
            dispatch(getPolicyList(params.farm_uuid));
        }
        else if (agentResult.message) {
            dispatch(getPolicyList(params.farm_uuid));
            dispatch(toastSuccess(agentResult.message));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
    });
};

export const getEGOperators = farmId => dispatch => {
    defaultAgent.get(`/api/equipment/group/v1/list`, { farm_uuid: farmId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setEGOperator(agentResult.data));
            dispatch(setEGOperator(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(setEGOperator([]));
            dispatch(toastSuccess(agentResult.message));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
    });
};

export const getFarmUsers = farmId => dispatch => {
    defaultAgent.get(`api/farm/user/assigned`, { farm_uuid: farmId }).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(setFarmUsers(agentResult.data));
            dispatch(setFarmUsers(agentResult.data));
        }
        else if (agentResult.message) {
            dispatch(setFarmUsers([]));
            dispatch(toastSuccess(agentResult.message));
        }
    }).catch(ex => {
        if (defaultAgent.isCancel(ex)) return console.log(`Get user settings: `, ex.message);
        dispatch(toastError(ex.message));
    });
};